export default __webpack_public_path__ + "static/media/parent-no-data-img.8b123c45.png";